module.exports = __webpack_public_path__ + "media/abs/abs027-4bed8014.svg";